//type options: GET, POST, PATCH
export function checkRouterPermission(type="GET", routeObject=undefined){
    if(!routeObject){
        routeObject = this.$router.currentRoute.value.matched[this.$router.currentRoute.value.matched.length - 1]
    }

	let temp = JSON.parse(this.$store.state.router_permissions);
    if(!temp){
        return false
    }
    
   
    let permAttr = "routerPermission"
    if(type == "POST"){
        permAttr = "postPermission"
    }
    else if(type == "PATCH"){
        permAttr = "patchPermission"
    }
    else if(type == "DELETE"){
        permAttr = "deletePermission"
    }

    let propsObject = routeObject.props

    if(propsObject.default){
        propsObject = propsObject.default
    }

    if (!propsObject[permAttr]) {
        return true;
    }

    for (let i = 0; i < propsObject[permAttr].length; i++) {
        if (temp.indexOf(propsObject[permAttr][i]) < 0) {
            return false;
        }
    }
    
    return true
} 

//check if all given permissions are met
export function checkFunctionPermission(functionNameArray){
    if(!functionNameArray){
        return false
    }

	let temp = JSON.parse(this.$store.state.router_permissions);
    if(!temp){
        return false
    }

    for (let i = 0; i < functionNameArray.length; i++) {
        if (temp.indexOf(functionNameArray[i]) < 0) {
            return false;
        }
    }
    
    return true
} 
